import { useContext } from 'react';

import { TagActionContext, TagValueContext } from './context';

const useTagValue = () => {
  const context = useContext(TagValueContext);
  if (!context) {
    throw new Error('useTagValue must be used within a <TagFormContext />');
  }
  return context;
};

const useTagAction = () => {
  const context = useContext(TagActionContext);
  if (!context) {
    throw new Error('useTagAction must be used within a <TagFormContext />');
  }
  return context;
};

export { useTagAction, useTagValue };
